import { useQuery } from '@tanstack/react-query'
import { query } from '../graphql'
import { notifyBugsnag, selectSystemData } from '../helpers'

export const useSystemQuery = ({ username }) => {
  return useQuery({
    queryKey: ['system'],
    queryFn: () => {
      return Promise.all(
        [
          'CURRENT_CHALLENGE_CONFIG_ID',
          'MAIL_TEMPLATES',
          'CHALLENGES',
          'CATEGORIES',
          'DIMENSIONS',
          'DIMENSIONS_PDF_REPORTS',
          'ANNOUNCEMENT'
        ].map((id) => query({ query: 'getSystem', variables: { id } }))
      )
    },
    select: (items) => {
      try {
        return selectSystemData(items)
      } catch (err) {
        notifyBugsnag(err)
      }
    },
    enabled: !!username
  })
}
